export default __webpack_public_path__ + "static/media/Circle.f30876fe.svg";